module.exports = __webpack_public_path__ + "media/images/lb/858-484e2b553a779f4d3693e87e422ae74d.svg";